import type { ReactNode } from "react";

interface EnterpriseRouteFrameProps {
  banner?: ReactNode;
  children?: ReactNode;
}

export function EnterpriseRouteFrame({
  banner,
  children,
}: EnterpriseRouteFrameProps) {
  return (
    <>
      {banner}
      {children}
    </>
  );
}
